const orders = [
  {
    id: "#10421",
    checkbox: false,
    date: "Week 20",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Lumberjack Co",
    customerImg: require("@/assets/img/team-2.jpg"),
    product: "Weekly Subscription",
    revenue: "$40,20",
  },
  {
    id: "#10422",
    checkbox: false,
    date: "Week 19",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Big Cranes Scaffolds",
    customerImg: require("@/assets/img/team-1.jpg"),
    product: "Weekly Subscription",
    revenue: "$42,00",
  },
  {
    id: "#10423",
    checkbox: false,
    date: "Week 18",
    status: "Pending",
    statusIcon: "fas fa-times",
    customer: "Michael Mirra",
    product: "Weekly Subscription",
    revenue: "$25,50",
  },
  {
    id: "#10424",
    checkbox: false,
    date: "Week 17",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Andrew Nichel",
    customerImg: require("@/assets/img/team-3.jpg"),
    product: "Weekly Subscription",
    revenue: "$19,40",
  },
  {
    id: "#10425",
    checkbox: false,
    date: "Week 16",
    status: "Pending",
    statusIcon: "fas fa-times",
    customer: "Sebastian Koga",
    customerImg: require("@/assets/img/team-4.jpg"),
    product: "Weekly Subscription",
    revenue: "$44,90",
  },
  {
    id: "#10426",
    checkbox: false,
    date: "Week 15",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Gilberts & Co",
    product: "Weekly Subscription",
    revenue: "$112,50",
  },
  {
    id: "#10427",
    checkbox: false,
    date: "Week 14",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Iryna Innda",
    product: "Weekly Subscription",
    revenue: "$200,00",
  },
  {
    id: "#10428",
    checkbox: false,
    date: "Week 13",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "National Roofers",
    product: "Weekly Subscription",
    revenue: "$350,00",
  },
  {
    id: "#10429",
    checkbox: false,
    date: "Week 12",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Timberland Roofers",
    customerImg: require("@/assets/img/team-5.jpg"),
    product: "Weekly Subscription",
    revenue: "$15,00",
  },
  {
    id: "#10430",
    checkbox: false,
    date: "Week 11",
    status: "Pending",
    statusIcon: "fas fa-times",
    customer: "Nyati Foundations",
    customerImg: require("@/assets/img/ivana-squares.jpg"),
    product: "Penalty",
    revenue: "$25,00",
  },
  {
    id: "#10431",
    checkbox: false,
    date: "Week 10",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Red Hot Constructors",
    product: "Weekly Subscription",
    revenue: "$164,90",
  },
  {
    id: "#10432",
    checkbox: false,
    date: "Week 9",
    status: "Paid",
    statusIcon: "fas fa-check",
    customer: "Brooks Roadworks",
    product: "Weekly Subscription",
    revenue: "$23,90",
  },
];

export default orders;
